/*
  Store Pinia para armazenar e manipular os dados do rascunho do REA.
  Permite salvar, carregar e resetar o rascunho no localStorage.
*/

import { defineStore } from 'pinia'
import { replaceBlobToIdb, extractIdbKeys } from '@/utils/helpers';

export const useDraftStore = defineStore('draft', {
  // Estado principal do rascunho, todos os campos relevantes do REA
  state: () => {
    return {
      data: {
        id: '',
        status: '',
        dtype: '',
        titulo: '',
        descricao: '',
        autores: [],
        autoresOriginais: [],
        tipoConteudo: '',
        area: '',
        idioma: '',
        tags: [],
        usoComercial: '',
        modificacao: '',
        isAdaptacao: false,      // Indica se é adaptação de outro REA
        reaOriginalId: '',       // ID do REA original (caso adaptação)
        licencaOriginal: null,   // Licença do REA original
        capaOriginal: '',        // Capa do REA original
        capa: '',                // Capa personalizada
        texto: '',               // Texto principal (TinyMCE)
        cards: [],               // Cards da trilha (caso trilha de aprendizagem)
        url: '',                 // URL de conteúdo externo/embedded
        comunidade: '',          // Comunidade associada
        arquivo: null,           // Arquivo para upload
      },
      update: false,             // Indica se está em modo de atualização
      revise: false,             // Indica se está em revisão
      draft: false,              // Indica se há rascunho aberto
      images: [],                // lista de chaves no IDB usadas no conteúdo
      imageMap: {},              // blobUrl -> key (para converter na hora de salvar)
      blobUrls: [],              // URLs blob: criadas para renderizar imagens do IDB (somente runtime)
      editorBlobUrls: [],
      previewBlobUrls: [],
    };
  },

  actions: {
    // Salva os dados do rascunho no localStorage, incluindo flags de controle
    setData(id) {
      const textoParaSalvar = replaceBlobToIdb(this.data.texto, this.imageMap);

      // mantém lista de imagens consistente com o HTML salvo
      this.images = extractIdbKeys(textoParaSalvar);

      const dados = {
        data: {
          id: this.data.id,
          status: this.data.status,
          dtype: this.data.dtype,
          titulo: this.data.titulo,
          descricao: this.data.descricao,
          autores: this.data.autores,
          autoresOriginais: this.data.autoresOriginais,
          tipoConteudo: this.data.tipoConteudo,
          area: this.data.area,
          idioma: this.data.idioma,
          tags: this.data.tags,
          usoComercial: this.data.usoComercial,
          modificacao: this.data.modificacao,
          isAdaptacao: this.data.isAdaptacao,
          reaOriginalId: this.data.reaOriginalId,
          licencaOriginal: this.data.licencaOriginal,
          capaOriginal: this.data.capaOriginal,
          capa: this.data.capa,
          texto: textoParaSalvar,
          cards: this.data.cards,
          url: this.data.url,
          comunidade: this.data.comunidade,
          arquivo: this.data.arquivo,
        },
        update: this.update,
        revise: this.revise,
        draft: this.draft
      }
      localStorage.setItem('draftOER' + id, JSON.stringify(dados));
    },

    // Carrega os dados do rascunho do localStorage, se houver
    loadData(id) {
      const savedDataRaw = localStorage.getItem('draftOER' + id);
      if (!savedDataRaw) return;

      const savedData = JSON.parse(savedDataRaw);

      // restaura o "data" do rascunho
      Object.assign(this.data, savedData.data || {});

      // restaura flags (isso estava faltando)
      this.update = !!savedData.update;
      this.revise = !!savedData.revise;
      this.draft  = !!savedData.draft;

      // (opcional, mas recomendado) restaura lista de imagens a partir do HTML salvo
      const html = this.data.texto || '';
      this.images = extractIdbKeys(html);

      // NÃO restaura imageMap/blobUrls; isso é runtime (e muda a cada sessão)
    },

    // Reseta o estado do rascunho e remove do localStorage
    reset(id) {
      this.data.id = '';
      this.data.status = '';
      this.data.dtype = '';
      this.data.titulo = '';
      this.data.descricao = '';
      this.data.autores = [];
      this.data.autoresOriginais = [];
      this.data.tipoConteudo = '';
      this.data.area = '';
      this.data.idioma = '';
      this.data.tags = [];
      this.data.usoComercial = '';
      this.data.modificacao = '';
      this.data.isAdaptacao = false;
      this.data.reaOriginalId = '';
      this.data.licencaOriginal = null;
      this.data.capaOriginal = '';
      this.data.capa = '';
      this.data.texto = '';
      this.data.cards = [];
      this.data.url = '';
      this.data.comunidade = '';
      this.data.arquivo = null;
      this.update = false;
      this.revise = false;
      this.draft = false;

      localStorage.removeItem('draftOER' + id);
    },
  },
})
